import { gql } from "@apollo/client";
import { Contact as contact } from "../fragments";

const FETCH_CONTACT = props => gql`
  query FetchContact($id: Int) {
    contact(id: $id) {
      ${contact(props)}
    }
  }
`;

const FETCH_CONTACTS_V2 = props => gql`
  query FetchContactsV2($input: AdvContactFilterInput!) {
    contactsV2(input: $input) {
      count
      edges {
        ${contact(props)}
      }
      sqlQuery
    }
  }
`;

const FETCH_CONTACTS_LIST = props => gql`
  query FetchContactsList($input: AdvContactFilterInput!) {
    contactsV2(input: $input) {
      count
      edges {
        id
        company
        country {
          id
          name
        }
        county
        defaultAddress {
          country {
            name
          }
          county
        }
        email
        img
        name
        salesUser {
          id
          name
        }
        title
        totalSpend
        type {
          id
          name
        }
      }
      sqlQuery
    }
  }
`;

/**
 * Lightweight query that asks the server for nothing but the
 * human-readable synopsis of the current Contact Search filters
 * (e.g. "Contact Search with Offers in the date range … against works
 * by Darren Almond"). Used by the Contacts primary nav to caption the
 * "Contact Search" button so users can see at a glance what was
 * searched for.
 *
 * `limit: 1` is set by the caller to keep the underlying contacts
 * query as cheap as possible — the resolver still does a `findAll`,
 * but only for one row and only when the field is actually requested.
 */
const FETCH_CONTACTS_SEARCH_SYNOPSIS = gql`
  query FetchContactsSearchSynopsis($input: AdvContactFilterInput!) {
    contactsV2(input: $input) {
      searchSynopsis
    }
  }
`;

const FETCH_CONTACT_LOCATIONS = gql`
  query FetchContactLocations {
    contactLocations
  }
`;

const FETCH_CONTACT_PRIMARY_ADDRESS = gql`
  query FetchContactPrimaryAddress($id: Int!) {
    contact(id: $id) {
      address
      address2
      address3
      country {
        id
        continent
        digraph
        name
      }
      county
      town
      postcode
    }
  }
`;

export {
  FETCH_CONTACT,
  FETCH_CONTACTS_V2,
  FETCH_CONTACTS_LIST,
  FETCH_CONTACTS_SEARCH_SYNOPSIS,
  FETCH_CONTACT_LOCATIONS,
  FETCH_CONTACT_PRIMARY_ADDRESS,
};
